<template>
    <a
        v-bind="$attrs"
        class="
            bg-gray-200
            py-2
            px-6
            rounded-full
            font-sans
            hover:bg-gray-300
            active:bg-black active:text-white
            disabled:opacity-25
        "
    >
        <slot></slot>
    </a>
</template>

<script>
export default {
    name: "AppLink",
};
</script>

<style scoped></style>
